import React from "react";

const Payment = () => {
  return (

    //only image added
    <div>
      <img className="w-100" src="https://www.intechnic.com/hubfs/Blog/Featured%20Images/Coming%20Soon,%20Gaining%20Now%20Tips%20for%20Effective%20Coming%20Soon%20Pages.jpg" alt="" />
    </div>
  );
};

export default Payment;
